const UNPAID_PAYMENT_STATUSES = new Set(['awaiting_payment', 'failed', 'refunded']);

export type PaidOrderAlertKind = 'paid' | 'unpaid' | 'unknown';

function asRecord(value: unknown): Record<string, unknown> | null {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null;
}

function readStatusField(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }
  const normalized = value.trim().toLowerCase();
  return normalized || null;
}

/** Reads paymentStatus from WS new-order, order-status-update, and FCM payload shapes. */
export function readPaymentStatusFromAlertPayload(data: unknown): string | null {
  const root = asRecord(data);
  if (!root) {
    return null;
  }

  const nestedData = asRecord(root['data']);
  const nestedPayload = asRecord(root['payload']);
  const candidates: unknown[] = [
    root['paymentStatus'],
    asRecord(root['order'])?.['paymentStatus'],
    nestedData?.['paymentStatus'],
    asRecord(nestedData?.['order'])?.['paymentStatus'],
    nestedPayload?.['paymentStatus'],
    asRecord(nestedPayload?.['data'])?.['paymentStatus'],
    asRecord(nestedData?.['data'])?.['paymentStatus'],
  ];

  for (const candidate of candidates) {
    const status = readStatusField(candidate);
    if (status) {
      return status;
    }
  }
  return null;
}

export function resolvePaidOrderAlert(data: unknown): PaidOrderAlertKind {
  const status = readPaymentStatusFromAlertPayload(data);
  if (!status) {
    return 'unknown';
  }
  if (status === 'paid') {
    return 'paid';
  }
  if (UNPAID_PAYMENT_STATUSES.has(status)) {
    return 'unpaid';
  }
  return 'unknown';
}
